module.exports = __webpack_public_path__ + "media/images/Finger-c532309ac6b41e6d246f51cb3c3603d7.png";